import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import TransferOfChargeContMain from "presentation/view/container/TransferOfCharge/TransferOfChargeContMain";

CommonEntrypoint(<TransferOfChargeContMain />)